import React from 'react';
import './DeliveryEvidencePanel.css';

export function deliveryEvidenceState(evidence = [], localDemo = false, requiredEvidence = ['ci', 'deployment'], requireQuality = false, taskState = null) {
  const stateFor = (phase, label) => {
    const record = evidence.filter((item) => item.phase === phase).at(-1);
    const status = record?.status === 'passed' ? 'approved'
      : record?.status === 'failed' ? 'failed'
        : record?.status === 'running' ? 'running'
          : record?.status === 'pending_approval' ? 'waiting' : 'pending';
    const statusLabel = ({
      approved: 'Aprobado', failed: 'Falló', running: 'En curso',
      waiting: 'En espera de aprobación', pending: 'Pendiente',
    }[status]);
    return { phase, label, status, statusLabel, record };
  };
  const ci = stateFor('ci', 'CI · validación automática');
  const deployment = stateFor('deployment', 'Despliegue · aprobación y entrega');
  const quality = stateFor('quality', 'Quality Guardian · criterios y pruebas');
  const gates = { ci, deployment, quality };
  const requiredGates = [
    ...requiredEvidence.map((phase) => gates[phase]).filter(Boolean),
    ...(requireQuality ? [quality] : []),
  ];
  const evidenceReady = requiredGates.every((gate) => gate.status === 'approved');
  const tasksReady = !taskState || taskState.tasks_ready;
  const ready = evidenceReady && tasksReady;
  const deploymentRequired = requiredEvidence.includes('deployment');
  let nextAction = 'Evidencia completa: ya puedes marcar la ejecución como terminada.';
  if (taskState && !taskState.tasks_ready) {
    nextAction = taskState.task_detail;
  } else if (ci.status === 'failed') {
    nextAction = 'Corrige la implementación y vuelve a ejecutar CI desde la PR.';
  } else if (ci.status === 'running') {
    nextAction = 'Espera el resultado de CI en GitHub Actions antes de avanzar.';
  } else if (ci.status !== 'approved' && localDemo) {
    nextAction = 'Registra evidencia simulada localmente para completar esta demo; no se llamará a GitHub Actions.';
  } else if (ci.status !== 'approved') {
    nextAction = 'Abre o actualiza la PR de implementación; FORGE recibirá la evidencia de CI desde GitHub Actions.';
  } else if (deploymentRequired && deployment.status === 'failed') {
    nextAction = 'Revisa el despliegue fallido, corrige la causa y ejecuta una nueva entrega.';
  } else if (deploymentRequired && deployment.status === 'running') {
    nextAction = 'Espera el resultado del despliegue en GitHub Actions.';
  } else if (deploymentRequired && deployment.status === 'waiting') {
    nextAction = 'Aprueba el environment configurado en GitHub Actions para continuar con el despliegue.';
  } else if (deploymentRequired && deployment.status !== 'approved') {
    nextAction = 'Solicita o espera la aprobación del environment y ejecuta el despliegue.';
  } else if (requireQuality && quality.status === 'failed') {
    nextAction = 'Quality Guardian rechazó la entrega; corrige los criterios o las pruebas y solicita una nueva revisión.';
  } else if (requireQuality && quality.status !== 'approved') {
    nextAction = 'Quality Guardian debe revisar los criterios de aceptación, pruebas y evidencia antes del cierre.';
  }
  return { ci, deployment, quality, gates: requiredGates, ready, evidenceReady, nextAction, deploymentRequired };
}

function DeliveryEvidencePanel({ evidence = [], localDemo = false, requiredEvidence = ['ci', 'deployment'], requireQuality = false, taskState = null }) {
  const delivery = deliveryEvidenceState(evidence, localDemo, requiredEvidence, requireQuality, taskState);
  const hasSimulatedEvidence = evidence.some((item) => item.source === 'forge_local_demo');
  return <section className="delivery-evidence" aria-label="Evidencia de entrega">
    <div className="delivery-evidence-heading"><div><b>Evidencia de entrega</b><small>{hasSimulatedEvidence || localDemo ? 'Demo local: evidencia simulada y aislada; no proviene de GitHub Actions.' : 'Recibida automáticamente desde GitHub Actions.'}</small></div><span className={`status-pill ${delivery.ready ? 'green' : 'amber'}`}>{delivery.ready ? 'Lista para cerrar' : 'Evidencia pendiente'}</span></div>
    <div className="delivery-evidence-gates">{delivery.gates.map((gate) => <article className={`delivery-evidence-gate ${gate.status}`} key={gate.phase}><div><b>{gate.label}</b><span>{gate.statusLabel}</span></div>{gate.record ? <small>{gate.record.workflow || 'GitHub Actions'} · <code>{gate.record.commit_sha || 'sin commit'}</code>{gate.record.environment ? ` · ${gate.record.environment}` : ''}{gate.record.pull_request_numbers?.length ? ` · PR #${gate.record.pull_request_numbers.join(', #')}` : ''}{gate.record.source === 'forge_local_demo' && ' · simulada localmente'}{gate.record.run_url && <> · <a href={gate.record.run_url} target="_blank" rel="noreferrer">Ver ejecución</a></>}</small> : <small>Aún no hay evidencia registrada.</small>}</article>)}</div>
    <p className="delivery-next-action"><b>Siguiente acción:</b> {delivery.nextAction}</p>
  </section>;
}

export default DeliveryEvidencePanel;
